import Vue from 'vue';
import Vuex from 'vuex';
import ModuleMD from './modules/ModuleMD';
import User from './modules/User';
import ObjectCache from './modules/ObjectCache';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    ModuleMD,
    User,
    ObjectCache
  }
});
